import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { RobotsExclusion } from '@portal-core/sites/models/robots-exclusion.model';

@CollectionStateSelectors({
  stateType: RobotsExclusionState
})
@State<RobotsExclusionState>({
  name: RobotsExclusionState.source,
})
@Injectable()
export class RobotsExclusionState extends CollectionStateBase {
  static source = 'RobotsExclusion';
  getSource(): string {
    return RobotsExclusionState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class RobotsExclusionDataService extends CollectionDataServiceBase<RobotsExclusion> {
  constructor(protected store: Store) {
    super(store, RobotsExclusionState);
  }
}
